
const SET_SALES_ORDERS = (state, fetchedSalesOrders) => {
  state.salesOrders = fetchedSalesOrders;
  state.outDated=false;
};

const SET_SEARCH_TERMS = (state, searchTerms) =>{
  state.searchTerms = searchTerms;
}

const SET_LOADING = (state, loadingState)=>{
  state.loading = loadingState;
}

const SET_SELECTED_SALES_ORDER = (state, salesOrder)=>{
  state.selectedSalesOrder = salesOrder;
  // Object.assign(state.selectedSalesOrder, salesOrder);
}

const SET_SELECTED_INDEX = (state, index) =>{
  state.selectedIndex = index;
}

const SET_SELECTED_SALES_ORDER_AS_INVOICED = (state, date)=>{
    state.selectedSalesOrder.invoiced_at = date;
}


const SET_STATUS = (state, status) =>{
  // console.log("SET_STATUS : ", status);
  if(state.selectedIndex != null){
    // Object.assign(state.salesOrders[state.selectedIndex].status, status);
    state.salesOrders[state.selectedIndex].status.id = status.id;
    state.salesOrders[state.selectedIndex].status.code = status.code;
    state.salesOrders[state.selectedIndex].fk_status_id = status.id;
  }

  Object.assign(state.selectedSalesOrder.status, status);


  state.selectedSalesOrder.statusLogs.push(status);
}

const SET_PACKAGES = (state, packages) =>{
  state.selectedSalesOrder.packages = packages;
}

const INVALIDATE_LIST = (state) =>{
  state.outDated = true;
}

const SET_ORDERNAME_AND_DIRECTION = (state, {orderName, direction})=>{
  state.orderBy.orderName = orderName;
  state.orderBy.direction = direction;
}

const SET_SORT_ICON = (state, icon)=>{
  state.sort_icon =icon;
}

const SET_COUNT = (state, count)=>{
  state.count = count;
}

const SET_PAGES = (state, pages)=>{
  state.pages = pages;
}

const SET_PAGE = (state, page)=>{
  state.page = page;
}

const DELETE_SELECTED_SALES_ORDER = (state)=>{
  state.salesOrders.splice(state.selectedIndex,1);
}

const CLONE_TO_SELECTED_SALES_ORDER = (state, salesOrder)=>{
  let cloneSO = _.cloneDeep(salesOrder);

  cloneSO.expected_delivery_date=cloneSO.expectedDeliveryDate!=null?cloneSO.expectedDeliveryDate.toString():null;
  if(cloneSO.expected_delivery_date!=null && _.isObject(cloneSO.expected_delivery_date)){
    cloneSO.expected_delivery_date = cloneSO.expected_delivery_date.toString();
  }
  cloneSO.expectedDeliveryDate=null;
  cloneSO.date = salesOrder.date
  if(cloneSO.date!=null && _.isObject(cloneSO.date)){
    cloneSO.date = cloneSO.date.toString();
  }
  delete cloneSO.expectedDeliveryDate;

  if(cloneSO.sales_rep!=null){
    closeSO.sales_rep = {};
    cloneSO.sales_rep.id=cloneSO.salesRepId;
  }
  cloneSO.salesRepId=null;
  delete cloneSO.salesRepId;

  if(cloneSO.shippingMethodId!=null){
    cloneSO.delivery_type={};
    cloneSO.delivery_type.id=cloneSO.shippingMethodId
  }
  cloneSO.shippingMethodId=null;
  delete cloneSO.shippingMethodId;

  if(cloneSO.quantities==null){
    cloneSO.quantities = {};
  }

  Object.assign(state.selectedSalesOrder, cloneSO);
  if(state.selectedIndex!=null){
    Object.assign(state.salesOrders[state.selectedIndex], cloneSO);
  }

}



const BUILD_HISTORIC_ACTIVITIES = (state) =>{
  state.selectedSalesOrderHistoricActivities = [];

  state.selectedSalesOrderHistoricActivities.push({
      content : 'Création de la commande',
      timestamp : state.selectedSalesOrder.created_at,
      type : 'primary',
      size : 'large',
      icon : 'el-icon-star-on',
      color : '#5f8fdf'
    })

  _.forEach(state.selectedSalesOrder.status_logs, status=>{
      if(status.code==="CONFIRMED"){
        state.selectedSalesOrderHistoricActivities.push({
          content : 'Commande confirmée',
          timestamp : status.created_at,
          type : 'success',
          color: '#67c23a',
          icon : 'el-icon-circle-check'})
      }else if(status.code==="INVOICED"){
        state.selectedSalesOrderHistoricActivities.push({
          content : 'Facturé',
          timestamp : status.created_at,
          type : 'warning',
          icon : 'el-icon-tickets'})
      }else if(status.code==="PACKED"){
        state.selectedSalesOrderHistoricActivities.push({
          content : 'Commande préparée',
          timestamp : status.created_at,
          type : 'info',
          icon : 'el-icon-takeaway-box'})
      }else if(status.code==="SHIPPED"){
        state.selectedSalesOrderHistoricActivities.push({
          content : 'Commande envoyée',
          timestamp : status.created_at,
          type : 'info',
          icon : 'el-icon-truck'})
      }else if(status.code==="FULLFILED"){
        state.selectedSalesOrderHistoricActivities.push({
          content : 'Commande reçue',
          timestamp : status.created_at,
          type : 'primary',
          icon : 'el-icon-success'})
      }else if(status.code==="CLOSED"){
        state.selectedSalesOrderHistoricActivities.push({
          content : 'Commande terminée',
          timestamp : status.created_at,
          type : 'success',
          color : '#67c23a',
          icon : 'el-icon-star-on'})
      }else if(status.code==="VOIDED"){
        state.selectedSalesOrderHistoricActivities.push({
          content : 'Commande annulée',
          timestamp : status.created_at,
          type : 'danger',
          color :'#ec205f',
          icon : 'el-icon-error'})
      }
  })

}

const SET_REPORT_DOWNLOADING = (state, reportDownloading) =>{
  state.reportDownloading=reportDownloading;
}

const SET_SALES_ORDER_LOADING = (state, salesOrderLoading) => {
  state.salesOrderLoading = salesOrderLoading;
}

const CHANGE_CHECKED_CUSTOMER_CLASSES_FILTER = (state, checkedCustomerClasses)=>{
  state.filters.checkedCustomerClasses = checkedCustomerClasses;
}

const SET_STATUS_FILTER = (state, statusFitler)=>{
  state.filters.status = statusFitler;
}

const RESET_FILTERS = (state)=>{
  state.filters.status = [];
  state.filters.date = null;
  state.filters.deliveryDate = null;
  state.filters.checkedCustomerClasses= [];
  state.filters.checkedTags=[];
  state.filters.checkedReps=[];
  state.filters.withoutReps=false;
  state.filters.productId = null;
  state.filters.customerId= null;
  state.filters.inventories = [];
}

const SET_DATE_FILTER = (state, dateFilter)=>{
  state.filters.date = dateFilter;
}

const SET_DELIVERY_DATE_FILTER = (state, deliveryDateFilter)=>{
  state.filters.deliveryDate = deliveryDateFilter;
}

const SET_CHECKED_TAGS_FILTER = (state, checkedTags)=>{
  state.filters.checkedTags = checkedTags
}

const SET_CHECKED_REPS = (state, checkedReps) => {
  state.filters.checkedReps = checkedReps;
}

const SET_WITHOUT_REPS_FILTER = (state, withoutReps) =>{
  state.filters.withoutReps = withoutReps;
}

const SET_FILTER_CUSTOMER_ID = (state, customerId) => {
  state.filters.customerId = customerId;
}

const SET_FILTER_INVENTORY_FILTER = (state, inventories) => {
  state.filters.inventories = inventories;
}


const SET_FILTER_PRODUCT_ID = (state, productId) => {
  state.filters.productId = productId;
}
const SET_FILTER_DELIVERY_TYPE = (state, deliveryType) => {
  state.filters.deliveryType = deliveryType;
}

const SET_MODE = (state, mode)=>{
  state.mode = mode;
}

const UPDATE_PACKAGE_INDEX = (state, { index, packageInfos }) => {
  // console.log('Index : ', index);
  // console.log('packageInfos : ', packageInfos);
  Object.assign(state.selectedSalesOrder.packages[index], packageInfos);
}

export default {
  UPDATE_PACKAGE_INDEX,
  SET_MODE,
  SET_SALES_ORDERS,
  SET_SEARCH_TERMS,
  SET_LOADING,
  SET_SELECTED_SALES_ORDER,
  SET_SELECTED_INDEX,
  SET_STATUS,
  BUILD_HISTORIC_ACTIVITIES,
  INVALIDATE_LIST,
  SET_ORDERNAME_AND_DIRECTION,
  SET_SORT_ICON,
  SET_COUNT,
  SET_PAGES,
  SET_PAGE,
  CLONE_TO_SELECTED_SALES_ORDER,
  DELETE_SELECTED_SALES_ORDER,
  SET_SELECTED_SALES_ORDER_AS_INVOICED,
  SET_REPORT_DOWNLOADING,
  CHANGE_CHECKED_CUSTOMER_CLASSES_FILTER,
  SET_STATUS_FILTER,
  RESET_FILTERS,
  SET_DATE_FILTER,
  SET_DELIVERY_DATE_FILTER,
  SET_CHECKED_TAGS_FILTER,
  SET_PACKAGES,
  SET_CHECKED_REPS,
  SET_WITHOUT_REPS_FILTER,
  SET_FILTER_CUSTOMER_ID,
  SET_FILTER_PRODUCT_ID,
  SET_FILTER_DELIVERY_TYPE,
  SET_SALES_ORDER_LOADING,
  SET_FILTER_INVENTORY_FILTER
};
